/**
 * React Query hook for fetching Aquarimate maintenance activities data
 */
import { useQuery } from '@tanstack/react-query';
import { api, type MaintenanceActivityFilters } from '@/api/maintenance';
import { useTank } from '@/contexts/TankContext';
import { CACHE_TIMES } from '@/config/cacheTimes';

export function useMaintenanceActivities(filters?: MaintenanceActivityFilters) {
  const { selectedTank } = useTank();
  const tankId = selectedTank?.id;

  return useQuery({
    queryKey: ['maintenance-activities', tankId, filters],
    queryFn: () => api.getMaintenanceActivities(tankId!, filters),
    enabled: !!tankId,
    // Keep data fresh
    staleTime: CACHE_TIMES.LIVE,
    // Retry on failure
    retry: 2,
  });
}
